import { Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  PoBreadcrumb,
  PoDialogService,
  PoPageAction,
  PoPageFilter,
  PoPageListComponent,
  PoTableAction,
  PoTableColumn,
  PoTableColumnSpacing,
  PoTableComponent,
  PoComboComponent,
  PoModalAction,
  PoModalComponent,
  PoComboOption,
  PoTagType,
  PoNotificationService
} from '@po-ui/ng-components';
import { PoPageDynamicTableCustomAction } from '@po-ui/ng-templates';
import { environment } from '../../../environments/environment';
import { SchemaBuilderService } from '../../core/menu/schema-builder.service';
import { HttpClient } from '@angular/common/http';
import { ListDataDto } from '../../core/common/list-data-dto';
import { Router } from '@angular/router';
import { ShortcutService } from '../../core/shortcut/shortcut.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-processamento-fichas',
  templateUrl: './processamento-fichas.component.html',
  styleUrls: ['./processamento-fichas.component.css'],
  standalone: false
})
export class ProcessamentoFichasComponent implements OnInit, OnDestroy {
  @ViewChild('dynamicTable', { static: true }) dynamicTable!: PoTableComponent;
  @ViewChild('pageListComponent', { static: true }) pageListComponent!: PoPageListComponent;
  @ViewChild('modalDetalhes', { static: true }) modalDetalhes!: PoModalComponent;
  @ViewChild('modalCancelamentoProcesso', { static: true }) modalCancelamentoProcesso!: PoModalComponent;

  isHideLoading = true;

  tableItens: any[] = [];
  itensDetalhes: any[] = [];
  columns: Array<PoTableColumn> = [];
  columnsDetalhes: Array<PoTableColumn> = [];
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;

  moreItens = false;
  page = 1;
  pageSize = 15;
  filter = '';
  disclaimerGroup: any;
  private disclaimers: any[] = [];
  tamanhoModal = 'xl';

  atualJob: any;

  private readonly shortcutSubscription: Subscription;
  private readonly httpClient = inject(HttpClient);
  private timerInterval: any;

  public readonly filterSettings: PoPageFilter = {
    action: this.filterAction.bind(this),
    placeholder: 'Pesquisar'
  };

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/modulo/status-job`;

  readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'CAT 83/2009' },
      { label: 'Processamento Fichas' },
    ]
  };

  readonly pageActions: Array<PoPageAction> = [
    {
      label: 'Novo processamento',
      action: () => this.router.navigate(['/processamento-fichas/novo']),
      icon: 'an an-plus'
    },
    {
      label: 'Atualizar',
      action: () => this.loadMore(true),
      icon: 'an an-plus'
    },
  ];

  readonly actions: PoTableAction[] = [
    {
      label: 'Ver detalhes',
      action: this.abrirDetalhes.bind(this),
      icon: 'an an-eye',
      type: 'default'
    },
    {
      label: 'Baixar arquivo',
      action: this.baixarArquivo.bind(this),
      icon: 'an an-file-arrow-down',
      type: 'default'
    },
    {
      label: 'Reprocessar',
      action: this.confirmReprocessamento.bind(this),
      icon: 'an an-arrow-counter-clockwise',
      type: 'default'
    },
    {
      separator: true,
      label: 'Cancelar processamento',
      action: this.confirmacaoCancelamentoProcesso.bind(this),
      icon: 'an an-stop-circle',
      type: 'danger'
    },
  ];

  constructor(
    private readonly schemaBuilderService: SchemaBuilderService,
    private readonly poNotificationService: PoNotificationService,
    private readonly poDialogService: PoDialogService,
    private readonly shortcutService: ShortcutService,
    private readonly router: Router,
    private readonly http: HttpClient
  ) {
    this.columns = this.getColumns();
    this.columnsDetalhes = this.getColumnsDetalhes();

    this.shortcutSubscription = this.shortcutService.getShortcuts().subscribe((event: KeyboardEvent) => {
      if (event.ctrlKey && event.key === 'b') {
        event.preventDefault();
        this.router.navigate(['/processamento-fichas/novo']);
      } else if (event.ctrlKey && event.key === 'f') {
        event.preventDefault();
        this.pageListComponent.filterInput.nativeElement.focus();
      }
    });
  }

  private refreshInterval: any;
  private readonly refreshTime = 10000; // 10 segundos

  ngOnInit() {
    this.disclaimerGroup = {
      title: 'Filtros:',
      disclaimers: [],
      change: this.onChangeDisclaimer.bind(this),
      remove: this.onClearDisclaimer.bind(this)
    };
    this.loadMore();
    this.startAutoRefresh();
    this.startTimer();
  }

  ngOnDestroy(): void {
    this.stopAutoRefresh();
    this.stopTimer();
  }

  populateDisclaimers(filters: Array<any>) {
    const property = filters.length > 1 ? 'advanced' : 'search';
    this.disclaimers = filters.map(value => ({ value, property }));

    if (this.disclaimers && this.disclaimers.length > 0) {
      this.disclaimerGroup.disclaimers = [...this.disclaimers];
    } else {
      this.disclaimerGroup.disclaimers = [];
    }
  }

  filterAction(labelFilter: string | Array<string>) {
    const filter = typeof labelFilter === 'string' ? [labelFilter] : [...labelFilter];
    this.populateDisclaimers(filter);
    this.filter = filter.toString();
    this.loadMore(true);
  }

  confirmDelete(item: any) {
    this.poDialogService.confirm({
      title: 'Exclusão de Registros',
      message: `Deseja realmente excluir o item selecionado?`,
      confirm: () => this.remove(item)
    });
  }

  confirmReprocessamento(item: any) {
    this.poDialogService.confirm({
      title: 'Reprocessamento de Competência',
      message: `Deseja realmente reprocessar a competência ${item.periodoArq} da empresa ${item.nomeCliente}?`,
      confirm: () => this.solicitarProcessamento(item)
    });
  }

  solicitarProcessamento(item: any) {
    this.httpClient.post(`${environment.apiUrl}/v1/modulo/calcula-modulos-lote-background`, {
      idCliente: item.idCliente,
      competenciaInicial: String(item.periodoArq),
      competenciaFinal: String(item.periodoArq)
    })
      .subscribe({
        next: (res: any) => {
          this.poNotificationService.success('Processamento solicitado com sucesso!');
          this.loadMore(true);
          this.atualizarSteps();
        },
        error: err => console.log('Cliente não encontrado', err)
      });
  }

  remove(item: any) {
    this.isHideLoading = false;
    this.http.delete(`${this.serviceApi}/${item.id}`).subscribe(
      () => {
        this.dynamicTable.removeItem(item);
        this.isHideLoading = true;
      },
      error => {
        console.error('Error deleting item:', error);
        this.isHideLoading = true;
      }
    );
  }

  edit(item: any) {
    this.router.navigate(['/codigos-internos-edit', item.id]);
  }

  resetTable() {
    this.loadMore(true);
  }
  onChangeDisclaimer(disclaimers: any) {
    this.disclaimers = disclaimers;
    this.loadMore(true);
  }
  onClearDisclaimer(disclaimers: any) {
    if (disclaimers.removedDisclaimer.property === 'search') {
      this.pageListComponent.clearInputSearch();
    }
    this.disclaimers = [];
    this.filter = '';
    this.loadMore(true);
  }

  loadMore(reset: boolean = false): void {
    this.isHideLoading = false;
    if (reset) {
      this.page = 1;
      this.http
        .get<ListDataDto>(`${this.serviceApi}?page=${this.page}&pageSize=${this.pageSize}&search=${this.filter}`)
        .subscribe(
          data => {
            this.tableItens = [];
            this.tableItens = [...this.tableItens, ...data.items];
            this.moreItens = data.hasNext;
            this.page++;
            this.isHideLoading = true;
          },
          error => {
            console.log(error);
            this.isHideLoading = true;
          }
        );
    } else {
      this.http
        .get<ListDataDto>(`${this.serviceApi}?page=${this.page}&pageSize=${this.pageSize}&search=${this.filter}`)
        .subscribe(
          data => {
            this.tableItens = [...this.tableItens, ...data.items];
            this.moreItens = data.hasNext;
            this.page++;
            this.isHideLoading = true;
          },
          error => {
            console.log(error);
            this.isHideLoading = true;
          }
        );
    }
  }

  getColumns(): Array<PoTableColumn> {
    return [
      { property: 'id', label: 'ID Job', type: 'string' },
      // { property: 'idCliente', label: 'ID Cliente', type: 'string' },
      { property: 'periodoArq', label: 'Competência', type: 'string' },
      { property: 'nomeCliente', label: 'Cliente', type: 'columnTemplate' },
      { property: 'dataInicio', label: 'Inicio', type: 'dateTime', format: 'dd/MM HH:mm' },
      { property: 'stepAtual', label: 'Etapa Atual', type: 'string', color: 'color-01' },
      {
        property: 'tempoTotalSegundos',
        label: 'Tempo Proc.',
        type: 'columnTemplate'
      },
      {
        property: 'status',
        type: 'label',
        labels: [
          { value: 'Processando', label: 'Processando', color: 'color-01', textColor: 'white' },
          { value: 'Concluido', label: 'Concluido', color: 'color-11', textColor: 'white' },
          { value: 'Erro', label: 'Falha Processamento', color: 'color-07', textColor: 'white' },
          { value: 'Cancelado', label: 'Cancelado', color: 'color-08', textColor: 'white' },
          { value: 'Aguardando', label: 'Aguardando', color: 'color-10', textColor: 'white' },
          { value: 'Pendente', label: 'Pendente', color: 'color-05', textColor: 'white' },

        ]
      },

    ];
  }

  getColumnsDetalhes(): Array<PoTableColumn> {
    return [
      { property: 'stepName', label: 'Etapa', type: 'string' },
      {
        property: 'status',
        type: 'label',
        labels: [
          { value: 'Processando', label: 'Processando', color: 'color-01', textColor: 'white' },

          { value: 'Concluido', label: 'Concluido', color: 'color-11', textColor: 'white' },
          { value: 'Erro', label: 'Falha Processamento', color: 'color-07', textColor: 'white' },
          { value: 'Cancelado', label: 'Cancelado', color: 'color-08', textColor: 'white' },
          { value: 'Pendente', label: 'Pendente', color: 'color-05', textColor: 'white' },
        ]
      },
      { property: 'dataInicio', label: 'Inicio', type: 'dateTime', format: 'dd/MM HH:mm' },
      { property: 'dataFim', label: 'Fim', type: 'dateTime', format: 'dd/MM HH:mm' },
    ];
  }
  atualizarSteps() {
    this.http.get<any[]>(`${this.serviceApi}/${this.atualJob.id}`).subscribe({
      next: (data: any) => {
        this.itensDetalhes = data?.steps;
      },
      error: error => {
        console.error('There was an error!', error);
      }
    });
  }

  abrirDetalhes(item: any) {
    this.atualJob = item;
    this.http.get<any[]>(`${this.serviceApi}/${item.id}`).subscribe({
      next: (data: any) => {
        this.itensDetalhes = data?.steps;
        this.modalDetalhes.open();
      },
      error: error => {
        console.error('There was an error!', error);
      }
    });
  }

  confirmacaoCancelamentoProcesso(item: any) {
    this.atualJob = item;
    this.modalCancelamentoProcesso.open();
  }

  cancelarProcessamento(item: any) {
    console.log(item);
    this.http.post<any[]>(`${this.serviceApi}/cancelar?jobId=${item.id}`, '').subscribe({
      next: (data: any) => {
        this.poNotificationService.success('Processamento cancelado com sucesso!');
        //this.atualizarSteps();
        this.loadMore(true);
      },
      error: error => {
        this.poNotificationService.error('Erro ao cancelar o processamento.' + error);
      }
    });
  }

  // Só permite regerar o TXT quando a etapa final (GeraTXT) foi a que falhou
  // e todas as demais etapas foram concluídas com sucesso.
  get podeRegerarTxt(): boolean {
    const steps = this.itensDetalhes || [];
    if (!steps.length) return false;
    const geraTxt = steps.find((s: any) => s.stepName === 'GeraTXT');
    if (!geraTxt || geraTxt.status !== 'Erro') return false;
    return steps.every((s: any) => s.stepName === 'GeraTXT' || s.status === 'Concluido');
  }

  regerarTxt(item: any) {
    this.http.post<any[]>(`${this.serviceApi}/regerar-txt?jobId=${item.id}`, '').subscribe({
      next: () => {
        this.poNotificationService.success('Regeração do arquivo TXT solicitada com sucesso!');
        this.modalDetalhes.close();
        this.loadMore(true);
      },
      error: error => {
        this.poNotificationService.error('Erro ao solicitar a regeração do TXT. ' + (error?.error?.message || error));
      }
    });
  }

  primaryAction: PoModalAction = {
    action: () => {
      this.cancelarProcessamento(this.atualJob);
      this.modalCancelamentoProcesso.close();
    },
    label: 'Confirmar'
  };

  secondaryAction: PoModalAction = {
    action: () => {
      this.modalCancelamentoProcesso.close();
    },
    label: 'Cancelar'
  };

  baixarArquivo(item: any) {
    if (item && item.arquivoSaida) {
      const url = `${environment.apiUrl}${environment.versionApi}/modulo/download-file?objectName=${encodeURIComponent(item.arquivoSaida)}`;
      this.http.get(url, { responseType: 'blob' })
        .subscribe({
          next: (blob: Blob) => {
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = item.arquivoSaida.split('/').pop() || 'arquivo.txt';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
          },
          error: (error) => {
            console.error('Erro ao baixar arquivo:', error);
            this.poNotificationService.error('Erro ao baixar o arquivo.');
          }
        });
    }
  }

  startAutoRefresh() {
    this.refreshInterval = setInterval(() => {
      const hasActiveJobs = this.tableItens.some(
        item => item.status === 'Processando' || item.status === 'Pendente'
      );
      if (!hasActiveJobs) return;

      const currentPageSize = this.tableItens.length || this.pageSize;
      this.http
        .get<ListDataDto>(`${this.serviceApi}?page=1&pageSize=${currentPageSize}&search=${this.filter}`)
        .subscribe({
          next: data => {
            this.tableItens = [...data.items];
            this.moreItens = data.hasNext;
          },
          error: error => {
            console.error('Error fetching data:', error);
          }
        });
    }, this.refreshTime);
  }

  stopAutoRefresh() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  private startTimer() {
    this.timerInterval = setInterval(() => {
      let changed = false;
      this.tableItens.forEach(item => {
        if (item.status === 'Processando' && item.dataInicio) {
          const inicio = new Date(item.dataInicio).getTime();
          const agora = Date.now();
          item.tempoTotalSegundos = Math.round((agora - inicio) / 1000);
          changed = true;
        }
      });
      if (changed) {
        this.tableItens = [...this.tableItens];
      }
    }, 1000);
  }

  private stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }
}
